import { Conditional } from 'types/ConditionalTypes'

export default (reports: Conditional[], id: number): number => {
  return reports.findIndex(report => report.conditionalId === id)
}
